export class Stack {
  constructor( existing ) {
    this.stack = [...existing || [] ];
  }

  push( item ) {
    return new Stack( [...this.stack, item] );
  }

  peek() {
    return this.stack[this.stack.length - 1];
  }

  pop() {
    return new Stack( this.stack.slice( 0, this.stack.length - 1 ) );
  }
}